export default __webpack_public_path__ + "static/media/GM.03c89d1f.svg";